import { observer } from "mobx-react";
import {
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import React from "react";
import { IMultiLanguageTranscriptionPayload } from "services/TranscriptionService";
import { useStore } from "utils/useStore";
import { AcxTranscriptionStore } from "../Stores/AcxTranscriptionStore";
import InputSearchTranscription from "./InputSearchTranscription";
import { SpeakerStore } from "../Stores/SpeakerStore/SpeakerStore";
import { TranscriptionSearchResult } from "components/Evaluation/Stores/EvalStore";

interface AcxTranscriptionSidebarProps {
    showTranslationUI?: boolean;
    showUnredactedUI?: boolean;
    translationLanguageCode?: string;
    handleChecked: (checked: boolean) => void;
    speakerStore: SpeakerStore | undefined;
    selectedLanguageCode?: string;
    onChangeLanguage?: (
        languageCode: IMultiLanguageTranscriptionPayload["languageCode"],
    ) => void;
    onResultClick?: (result: TranscriptionSearchResult) => void;
}

export const AcxTranscriptionSidebar: React.FC<AcxTranscriptionSidebarProps> =
    observer(
        ({
            showTranslationUI,
            showUnredactedUI,
            translationLanguageCode,
            selectedLanguageCode,
            speakerStore,
            onChangeLanguage,
            handleChecked,
            onResultClick,
        }) => {
            const store = useStore(AcxTranscriptionStore);
            const showTranslationWithLanguageCode =
                showTranslationUI && translationLanguageCode !== undefined;

            return (
                <>
                    <Grid
                        item
                        xs={12}
                        style={{ paddingRight: "10px" }}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            minWidth: "10%",
                            paddingLeft: "15px",
                            paddingTop: "10px",
                        }}
                    >
                        {speakerStore && (
                            <Grid sx={{ width: "100%", position: "relative" }}>
                                <InputSearchTranscription
                                    alignment="left"
                                    speakerStore={speakerStore}
                                    disabled={store.isCheckedEddyEffectP2}
                                    inputWidth="100%"
                                    onResultClick={onResultClick}
                                />
                            </Grid>
                        )}
                    </Grid>
                    {(showTranslationWithLanguageCode || showUnredactedUI) && (
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                minWidth: "10%",
                                paddingLeft: "15px",
                                paddingTop: "10px",
                            }}
                            style={{ paddingRight: "10px" }}
                        >
                            <Typography variant="h2" gutterBottom={true}>
                                Transcript Language
                            </Typography>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    aria-label="language"
                                    value={selectedLanguageCode}
                                    name="radio-buttons-group"
                                    onChange={(event) => {
                                        onChangeLanguage?.(
                                            event.target
                                                .value as IMultiLanguageTranscriptionPayload["languageCode"],
                                        );
                                    }}
                                    defaultValue={selectedLanguageCode}
                                >
                                    {showUnredactedUI && (
                                        <>
                                            <FormControlLabel
                                                value="en"
                                                control={<Radio />}
                                                label="English"
                                            />
                                            <FormControlLabel
                                                value="en-unredacted"
                                                control={<Radio />}
                                                label="Unredacted"
                                            />
                                        </>
                                    )}
                                    {!showUnredactedUI &&
                                        showTranslationWithLanguageCode && (
                                            <>
                                                <FormControlLabel
                                                    value="en"
                                                    control={<Radio />}
                                                    label="English"
                                                />
                                                <FormControlLabel
                                                    value={
                                                        translationLanguageCode
                                                    }
                                                    control={<Radio />}
                                                    label="Original"
                                                />
                                            </>
                                        )}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    )}
                    {/* disabling this for now as its completely broken */}
                    {/* <Grid
                        item
                        xs={12}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            minWidth: "10%",
                            paddingLeft: "15px",
                            paddingTop: "10px",
                        }}
                    >
                        <Typography variant="h2" gutterBottom={true}>
                            Models
                        </Typography>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={store.isCheckedEddyEffectP2}
                                    onChange={(e) => {
                                        handleChecked(e.target.checked);
                                    }}
                                    name="SampleToMiddleOfTheFunnel"
                                />
                            }
                            label={
                                <Typography
                                    color={"textSecondary"}
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                    }}
                                    variant={"subtitle2"}
                                >
                                    Eddy Effect Signal
                                </Typography>
                            }
                        />
                    </Grid> */}
                </>
            );
        },
    );
